<div class="entry-page">
  <!-- Header -->
  <header class="page-header">
    <button class="btn-icon" title="بازگشت" (click)="goBack()">
      <i class="fa fa-arrow-right"></i>
    </button>
    <h1 class="page-title">
      {{
        modeId == 1 ? 'ثبت متحرک با ردیاب' :
        modeId == 2 ? 'ثبت متحرک بدون ردیاب' :
        modeId == 3 ? 'ثبت متحرک اداری' : ''
      }}
    </h1>
    <button class="btn-icon" title="راهنما" (click)="showGuide()">
      <i class="fa fa-question"></i>
    </button>
  </header>
  <!-- Body -->
  <main class="page-body">
    <!-- وضعیت ردیاب (خودرو اداری) -->
    <ng-container *ngIf="modeId == 3">
      <div class="tracker-banner">
        <label>وضعیت ردیاب:</label>
        <div class="segmented">
          <input type="radio" name="gpsStatus" id="btnradio1" autocomplete="off" checked
            (click)="generateUnitId(false)" />
          <label for="btnradio1">تحت ردیاب</label>
          <input type="radio" name="gpsStatus" id="btnradio2" autocomplete="off"
            (click)="generateUnitId(true)" />
          <label for="btnradio2">بدون ردیاب</label>
        </div>
      </div>
    </ng-container>
    <!-- ========== فرم کامل: با ردیاب / اداری ========== -->
    <div *ngIf="modeId == 1 || modeId == 3" [formGroup]="gpsForm" [class.form-submitted]="formSubmitted">

      <!-- 1. اطلاعات دستگاه و ردیاب -->
      <section class="form-card">
        <div class="form-card-header">
          <i class="fa fa-microchip"></i>
          <div class="header-text">
            <h3>اطلاعات دستگاه و ردیاب</h3>
            <small class="subtitle">شناسه، نوع ردیاب و بازه ذخیره‌سازی اطلاعات</small>
          </div>
        </div>
        <div class="form-card-body">
          <div class="form-grid">
            <div class="form-group">
              <label class="field-label">شناسه دستگاه <span class="req">*</span></label>
              <div class="input-wrap">
                <input type="text" id="deviceId" formControlName="strUnitId" [readonly]="isDeviceIdLocked"
                  placeholder="فقط عدد" inputmode="numeric" maxlength="15"
                  oninput="this.value = this.value.replace(/[^0-9]/g,'')" />
                <div class="input-action" *ngIf="!isDeviceIdLocked">
                  <button type="button" class="btn btn-sm btn-outline" (click)="verifyDeviceId()"
                    [disabled]="checkingDeviceId">
                    <span *ngIf="checkingDeviceId" class="spinner-border spinner-border-sm"></span>
                    <span *ngIf="!checkingDeviceId">بررسی شناسه</span>
                  </button>
                </div>
              </div>
            </div>
            <div class="form-group">
              <label class="field-label">نوع ردیاب <span class="req">*</span></label>
              <ng-select formControlName="iGPS" [items]="gpsTypeList" bindLabel="strComment" bindValue="iGPS"
                placeholder="جستجو و انتخاب ..." [loading]="gpsTypeList.length === 0"
                loadingText="لطفا اندکی صبر کنید ..." notFoundText="موردی یافت نشد"
                [clearable]="true" [readonly]="gpsTypeLocked" appendTo="body">
              </ng-select>
            </div>
            <div class="form-group">
              <label class="field-label">شماره سیم‌کارت ردیاب</label>
              <input type="tel" formControlName="strCellNo" placeholder="09xxxxxxxxx" maxlength="11"
                oninput="this.value = this.value.replace(/[^0-9]/g,'')" (keypress)="isDigitKey($event)" />
            </div>
            <div class="form-group">
              <label class="field-label">رمز عبور دستگاه</label>
              <input type="text" formControlName="strPassword" placeholder="••••••••" />
            </div>
            <div class="form-group">
              <label class="field-label">ولتاژ روشن</label>
              <div class="input-wrap">
                <input type="text" formControlName="fMinVoltage" placeholder="مثلاً ۱۲.۴" />
                <div class="input-action">
                  <button type="button" class="btn btn-sm btn-outline" (click)="analyzeVoltage()" title="تحلیل ولتاژ روشن">
                    <i class="fa fa-calculator"></i>&nbsp;تحلیل خودکار
                  </button>
                </div>
              </div>
            </div>
            <div class="form-group clockpicker">
              <label class="field-label">زمان شروع ذخیره اطلاعات ردیاب</label>
              <input type="text" formControlName="strStartTime" id="startTime" readonly placeholder="۰۰:۰۰" />
            </div>
            <div class="form-group clockpicker">
              <label class="field-label">زمان پایان ذخیره اطلاعات ردیاب</label>
              <input type="text" formControlName="strEndTime" id="endTime" readonly placeholder="۰۰:۰۰" />
            </div>
          </div>
        </div>
      </section>

      <!-- 2. مشخصات پایه متحرک -->
      <section class="form-card">
        <div class="form-card-header">
          <i class="fa fa-car"></i>
          <div class="header-text">
            <h3>مشخصات پایه متحرک</h3>
            <small class="subtitle">نوع، گروه، نام، تیپ و مشخصات هویتی متحرک</small>
          </div>
        </div>
        <div class="form-card-body">
          <div class="form-grid">
            <div class="form-group">
              <label class="field-label">نوع کاربری <span class="req">*</span></label>
              <select formControlName="tiMobileUsage">
                <option class="text-center" [value]="-1">انتخاب کنید</option>
                <option class="text-center" *ngFor="let item of mobileUsages" value="{{item.tiMobileUsage}}">
                  {{item.strComment}}
                </option>
              </select>
            </div>
            <div class="form-group">
              <label class="field-label">نوع متحرک <span class="req">*</span></label>
              <select formControlName="tiMobileType">
                <option class="text-center" [value]="-1">انتخاب کنید</option>
                <option class="text-center" *ngFor="let item of vehicleKinds" value="{{item.tiMobileType}}">
                  {{item.strComment}}
                </option>
              </select>
            </div>
            <div class="form-group">
              <label class="field-label">گروه متحرک</label>
              <select formControlName="tiMobileGroup">
                <option class="text-center" [value]="-1">انتخاب کنید</option>
                <option class="text-center" *ngFor="let item of carGroups" value="{{item.tiMobileGroup}}">
                  {{item.strComment}}
                </option>
              </select>
            </div>
            <div class="form-group">
              <label class="field-label">نام برند <span class="req">*</span></label>
              <ng-select formControlName="tiGPSType" [items]="carNameList" bindLabel="strComment" bindValue="tiGPSType"
                placeholder="جستجو و انتخاب ..." [loading]="carNameList.length === 0"
                loadingText="لطفا اندکی صبر کنید ..." notFoundText="موردی یافت نشد"
                [clearable]="true" appendTo="body">
              </ng-select>
            </div>
            <div class="form-group">
              <label class="field-label">تیپ</label>
              <input type="text" formControlName="strVehicleType" placeholder="مثلاً پژو ۲۰۶ تیپ ۵" />
            </div>
            <div class="form-group">
              <label class="field-label">کد متحرک</label>
              <input type="text" formControlName="iCode" placeholder="عدد"
                oninput="this.value = this.value.replace(/[^0-9]/g,'')" />
            </div>
            <div class="form-group">
              <label class="field-label">آیکون متحرک</label>
              <ng-select [(ngModel)]="selectedCarIcon" [ngModelOptions]="{standalone: true}"
                [items]="carIconList" bindLabel="strComment"
                placeholder="جستجو و انتخاب ..." [loading]="carIconList.length === 0"
                loadingText="لطفا اندکی صبر کنید ..." notFoundText="موردی یافت نشد"
                [clearable]="true" appendTo="body" (change)="onCarIconChange($event)"
                [class.field-invalid]="formSubmitted && !selectedCarIcon">
                <ng-template ng-option-tmp let-item="item">
                  <img [src]="'data:image/jpeg;base64,' + item.strMobileIcon" alt="" />
                  <span>{{ item.strComment }}</span>
                </ng-template>
              </ng-select>
            </div>
            <div class="form-group">
              <label class="field-label">رنگ متحرک</label>
              <input type="text" formControlName="strColor" placeholder="مثلاً سفید" />
            </div>
            <div class="form-group">
              <label class="field-label">سال ساخت</label>
              <input type="text" formControlName="iYearConstruction" placeholder="۱۴۰۲" maxlength="4" />
            </div>
            <div class="form-group">
              <label class="field-label">VIN</label>
              <input type="text" formControlName="strVIN" placeholder="۱۷ کاراکتر" maxlength="17" />
            </div>
          </div>
        </div>
      </section>

      <!-- 3. ظرفیت و سوخت -->
      <section class="form-card">
        <div class="form-card-header">
          <i class="fa fa-tachometer"></i>
          <div class="header-text">
            <h3>ظرفیت و سوخت</h3>
            <small class="subtitle">ظرفیت سرنشین، سوخت، مصرف و محدوده سرعت</small>
          </div>
        </div>
        <div class="form-card-body">
          <div class="form-grid">
            <div class="form-group">
              <label class="field-label">ظرفیت (تعداد سرنشین)</label>
              <input type="text" formControlName="tiPassenger" placeholder="مثلاً ۵"
                oninput="this.value = this.value.replace(/[^0-9]/g,'')" />
            </div>
            <div class="form-group">
              <label class="field-label">نوع سوخت</label>
              <select formControlName="tiFuelType">
                <option class="text-center" [value]="0">ندارد</option>
                <option class="text-center" [value]="1">بنزین</option>
                <option class="text-center" [value]="2">نفت گاز</option>
                <option class="text-center" [value]="3">هیبرید</option>
                <option class="text-center" [value]="4">برقی</option>
              </select>
            </div>
            <div class="form-group">
              <label class="field-label">ظرفیت باک (لیتر)</label>
              <input type="text" formControlName="fFuelTankCapacity" placeholder="مثلاً ۴۵.۰"
                oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1').replace(/^(\d*\.\d{1}).*$/, '$1');" />
            </div>
            <div class="form-group">
              <label class="field-label">مصرف شهری (L/100)</label>
              <input type="text" formControlName="fGasPer100" placeholder="مثلاً ۷.۵" />
            </div>
            <div class="form-group">
              <label class="field-label">مصرف درجا (L/H)</label>
              <input type="text" formControlName="fGasPer100_Tr" placeholder="مثلاً ۱.۲" />
            </div>
            <div class="form-group">
              <label class="field-label">توان (HP)</label>
              <input type="text" formControlName="fGasPer100_HW" placeholder="مثلاً ۱۱۰" />
            </div>
            <div class="form-group">
              <label class="field-label">کیلومتر فعلی</label>
              <input type="text" formControlName="fLastKM" placeholder="مثلاً ۱۲۵۰۰۰"
                oninput="this.value = this.value.replace(/[^0-9]/g,'')" />
            </div>
            <div class="form-group">
              <label class="field-label">حداکثر سرعت مجاز</label>
              <input type="text" formControlName="tiMaxSpeed" placeholder="مثلاً ۱۲۰"
                oninput="this.value = this.value.replace(/[^0-9]/g,'')" (keypress)="isDigitKey($event)" />
            </div>
          </div>
        </div>
      </section>

      <!-- 4. راننده / مالک -->
      <section class="form-card">
        <div class="form-card-header">
          <i class="fa fa-user"></i>
          <div class="header-text">
            <h3>اطلاعات راننده / مالک</h3>
            <small class="subtitle">مشخصات تماس راننده یا مالک</small>
          </div>
        </div>
        <div class="form-card-body">
          <div class="form-grid">
            <div class="form-group">
              <label class="field-label">نام و نام خانوادگی راننده</label>
              <input type="text" formControlName="strFullName" placeholder="نام کامل" />
            </div>
            <div class="form-group">
              <label class="field-label">موبایل راننده</label>
              <input type="tel" formControlName="strMobile" placeholder="09xxxxxxxxx" maxlength="11"
                oninput="this.value = this.value.replace(/[^0-9]/g,'')" />
            </div>
            <div class="form-group">
              <label class="field-label">شماره پرسنلی</label>
              <input type="text" formControlName="strPersonnelID" placeholder="شماره پرسنلی" [disabled]="isLoading" />
            </div>
          </div>
        </div>
      </section>

      <!-- 5. پلاک -->
      <section class="form-card">
        <div class="form-card-header">
          <i class="fa fa-id-card"></i>
          <div class="header-text">
            <h3>پلاک خودرو</h3>
            <small class="subtitle">نوع پلاک و شماره کامل پلاک</small>
          </div>
        </div>
        <div class="form-card-body">
          <div class="form-grid">
            <div class="form-group">
              <label class="field-label">نوع پلاک</label>
              <select formControlName="tiPlateType">
                <option class="text-center" [value]="-1">انتخاب کنید</option>
                <option class="text-center" *ngFor="let item of plateTypes" value="{{item.tiPlateType}}">
                  {{item.strComment}}
                </option>
              </select>
            </div>
            <div class="form-group span-2">
              <label class="field-label">پلاک <span class="req">*</span></label>
              <div class="plate-box" dir="rtl">
                <input type="text" placeholder="ایران" [maxLength]="2" (keypress)="isDigitKey($event)"
                  formControlName="Plak4" />
                <input type="text" placeholder="_ _ _" [maxLength]="3" (keypress)="isDigitKey($event)"
                  formControlName="Plak3" />
                <select formControlName="Plak2">
                  <option value="الف">الف</option>
                  <option value="ب">ب</option>
                  <option value="پ">پ</option>
                  <option value="ت">ت</option>
                  <option value="ج">ج</option>
                  <option value="د">د</option>
                  <option value="س">س</option>
                  <option value="ص">ص</option>
                  <option value="ط">ط</option>
                  <option value="ق">ق</option>
                  <option value="ع">ع</option>
                  <option value="ک">ک</option>
                  <option value="ل">ل</option>
                  <option value="م">م</option>
                  <option value="ن">ن</option>
                  <option value="و">و</option>
                  <option value="ه">ه</option>
                  <option value="ی">ی</option>
                </select>
                <input type="text" placeholder="_ _" [maxLength]="2" (keypress)="isDigitKey($event)"
                  formControlName="Plak1" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 6. تاریخ‌ها و تکمیلی -->
      <section class="form-card">
        <div class="form-card-header">
          <i class="fa fa-calendar"></i>
          <div class="header-text">
            <h3>تاریخ‌ها و اطلاعات تکمیلی</h3>
            <small class="subtitle">تاریخ ثبت، اعتبار و توضیحات اضافه</small>
          </div>
        </div>
        <div class="form-card-body">
          <div class="form-grid">
            <div class="form-group">
              <label class="field-label">تاریخ ثبت</label>
              <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"
                [dateInitValue]="true" [dateFormat]="'jYYYY/jMM/jDD'">
                <input type="text" formControlName="strDefinationDate" placeholder="۱۴۰۳/۰۶/۱۵" />
              </ng-persian-datepicker>
            </div>
            <div class="form-group" *ngIf="carId && permissions.bEditExpiredDate">
              <label class="field-label">تاریخ پایان اعتبار</label>
              <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"
                [dateInitValue]="true" [dateFormat]="'jYYYY/jMM/jDD'">
                <input type="text" formControlName="strValidDate" placeholder="۱۴۰۴/۰۶/۱۵" />
              </ng-persian-datepicker>
            </div>
            <div class="form-group">
              <label class="field-label">کد تقسیمات کشوری</label>
              <input type="text" formControlName="strProvinceCode" maxlength="15" placeholder="حداکثر ۱۵ کاراکتر" />
            </div>
            <div class="form-group span-full">
              <label class="field-label">توضیحات</label>
              <textarea formControlName="strComment" placeholder="توضیحات اختیاری..."></textarea>
            </div>
          </div>
        </div>
      </section>

      <!-- 7. سوییچ‌ها و سنسورها -->
      <section class="form-card">
        <div class="form-card-header">
          <i class="fa fa-toggle-on"></i>
          <div class="header-text">
            <h3>سوییچ‌ها و سنسورها</h3>
            <small class="subtitle">وضعیت فعال‌بودن و سنسورهای متصل</small>
          </div>
        </div>
        <div class="form-card-body">
          <div class="switches-grid">
            <label class="switch-item">
              <span>فعال</span>
              <span class="toggle"><input type="checkbox" formControlName="bActive" /><span class="slider"></span></span>
            </label>
            <label class="switch-item" *ngIf="permissions?.bSetSeepad && modeId != 3">
              <span>سیپاد</span>
              <span class="toggle"><input type="checkbox" formControlName="bSeepad" /><span class="slider"></span></span>
            </label>
            <label class="switch-item" *ngIf="permissions?.bPeysepar">
              <span>اداری</span>
              <span class="toggle"><input type="checkbox" formControlName="bOfficial" /><span class="slider"></span></span>
            </label>
            <ng-container *ngIf="modeId == 1 || gpsForm.get('bHasGPS').value">
              <label class="switch-item">
                <span>تانکر</span>
                <span class="toggle"><input type="checkbox" formControlName="bTanker" /><span class="slider"></span></span>
              </label>
              <label class="switch-item">
                <span>کنترل سوخت</span>
                <span class="toggle"><input type="checkbox" formControlName="bFuelSensor" /><span class="slider"></span></span>
              </label>
              <label class="switch-item">
                <span>دش‌کم</span>
                <span class="toggle"><input type="checkbox" formControlName="bDashCam" /><span class="slider"></span></span>
              </label>
              <label class="switch-item">
                <span>سنسور وزن</span>
                <span class="toggle"><input type="checkbox" formControlName="bWeightSensor" /><span class="slider"></span></span>
              </label>
              <label class="switch-item">
                <span>سنسور دما</span>
                <span class="toggle"><input type="checkbox" formControlName="bTemperatureSensor" /><span class="slider"></span></span>
              </label>
              <label class="switch-item">
                <span>اتصال به ECU</span>
                <span class="toggle"><input type="checkbox" formControlName="bOBD2" /><span class="slider"></span></span>
              </label>
            </ng-container>
            <label class="switch-item">
              <span>فلومتر</span>
              <span class="toggle"><input type="checkbox" formControlName="bFlowmeter" /><span class="slider"></span></span>
            </label>
          </div>
        </div>
      </section>
    </div>
    <!-- ========== فرم خلاصه: بدون ردیاب ========== -->
    <div *ngIf="modeId == 2" [formGroup]="plainForm" [class.form-submitted]="formSubmitted">
      <section class="form-card">
        <div class="form-card-header">
          <i class="fa fa-car"></i>
          <div class="header-text">
            <h3>ثبت خودرو بدون ردیاب</h3>
            <small class="subtitle">فرم خلاصه مخصوص خودروهای فاقد دستگاه ردیاب</small>
          </div>
        </div>
        <div class="form-card-body">
          <div class="form-grid">
            <div class="form-group">
              <label class="field-label">نوع پلاک</label>
              <select formControlName="tiPlateType">
                <option class="text-center" [value]="-1">انتخاب کنید</option>
                <option class="text-center" *ngFor="let item of plateTypes" value="{{item.tiPlateType}}">
                  {{item.strComment}}
                </option>
              </select>
            </div>
            <div class="form-group span-2">
              <label class="field-label">پلاک <span class="req">*</span></label>
              <div class="plate-box" dir="rtl">
                <input type="text" placeholder="ایران" [maxLength]="2" (keypress)="isDigitKey($event)"
                  formControlName="Plak4" />
                <input type="text" placeholder="_ _ _" [maxLength]="3" (keypress)="isDigitKey($event)"
                  formControlName="Plak3" />
                <select formControlName="Plak2">
                  <option value="الف">الف</option>
                  <option value="ب">ب</option>
                  <option value="پ">پ</option>
                  <option value="ت">ت</option>
                  <option value="ج">ج</option>
                  <option value="د">د</option>
                  <option value="س">س</option>
                  <option value="ص">ص</option>
                  <option value="ط">ط</option>
                  <option value="ق">ق</option>
                  <option value="ع">ع</option>
                  <option value="ک">ک</option>
                  <option value="ل">ل</option>
                  <option value="م">م</option>
                  <option value="ن">ن</option>
                  <option value="و">و</option>
                  <option value="ه">ه</option>
                  <option value="ی">ی</option>
                </select>
                <input type="text" placeholder="_ _" [maxLength]="2" (keypress)="isDigitKey($event)"
                  formControlName="Plak1" />
              </div>
            </div>
            <div class="form-group">
              <label class="field-label">نوع کاربری</label>
              <select formControlName="tiMobileUsage">
                <option class="text-center" [value]="-1">انتخاب کنید</option>
                <option class="text-center" *ngFor="let item of mobileUsages" value="{{item.tiMobileUsage}}">
                  {{item.strComment}}
                </option>
              </select>
            </div>
            <div class="form-group">
              <label class="field-label">نوع خودرو</label>
              <select formControlName="tiMobileType">
                <option class="text-center" [value]="-1">انتخاب کنید</option>
                <option class="text-center" *ngFor="let item of vehicleKinds" value="{{item.tiMobileType}}">
                  {{item.strComment}}
                </option>
              </select>
            </div>
            <div class="form-group">
              <label class="field-label">گروه خودرو</label>
              <select formControlName="tiMobileGroup">
                <option class="text-center" [value]="-1">انتخاب کنید</option>
                <option class="text-center" *ngFor="let item of carGroups" value="{{item.tiMobileGroup}}">
                  {{item.strComment}}
                </option>
              </select>
            </div>
            <div class="form-group">
              <label class="field-label">نام خودرو</label>
              <ng-select formControlName="tiGPSType" [items]="carNameList" bindLabel="strComment" bindValue="tiGPSType"
                placeholder="جستجو و انتخاب ..." [loading]="carNameList.length === 0"
                loadingText="لطفا اندکی صبر کنید ..." notFoundText="موردی یافت نشد"
                [clearable]="true" appendTo="body">
              </ng-select>
            </div>
            <div class="form-group">
              <label class="field-label">تیپ خودرو</label>
              <input type="text" formControlName="strVehicleType" placeholder="مثلاً پژو ۲۰۶ تیپ ۵" />
            </div>
            <div class="form-group">
              <label class="field-label">کد خودرو</label>
              <input type="text" formControlName="iCode" placeholder="عدد"
                oninput="this.value = this.value.replace(/[^0-9]/g,'')" />
            </div>
            <div class="form-group">
              <label class="field-label">ظرفیت خودرو</label>
              <input type="text" formControlName="tiPassenger" placeholder="مثلاً ۵"
                oninput="this.value = this.value.replace(/[^0-9]/g,'')" />
            </div>
            <div class="form-group">
              <label class="field-label">نوع سوخت</label>
              <select formControlName="tiFuelType">
                <option class="text-center" [value]="0">ندارد</option>
                <option class="text-center" [value]="1">بنزین</option>
                <option class="text-center" [value]="2">نفت گاز</option>
                <option class="text-center" [value]="3">هیبرید</option>
                <option class="text-center" [value]="4">برقی</option>
              </select>
            </div>
            <div class="form-group">
              <label class="field-label">ظرفیت باک (لیتر)</label>
              <input type="text" formControlName="fFuelTankCapacity" placeholder="مثلاً ۴۵.۰"
                oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1').replace(/^(\d*\.\d{1}).*$/, '$1');" />
            </div>
            <div class="form-group">
              <label class="field-label">آیکون خودرو</label>
              <ng-select [(ngModel)]="selectedCarIcon" [ngModelOptions]="{standalone: true}"
                [items]="carIconList" bindLabel="strComment"
                placeholder="جستجو و انتخاب ..." [loading]="carIconList.length === 0"
                loadingText="لطفا اندکی صبر کنید ..." notFoundText="موردی یافت نشد"
                [clearable]="true" appendTo="body" (change)="onCarIconChange($event)"
                [class.field-invalid]="formSubmitted && !selectedCarIcon">
                <ng-template ng-option-tmp let-item="item">
                  <img [src]="'data:image/jpeg;base64,' + item.strMobileIcon" alt="" />
                  <span>{{ item.strComment }}</span>
                </ng-template>
              </ng-select>
            </div>
            <div class="form-group">
              <label class="field-label">سال ساخت</label>
              <input type="text" formControlName="iYearConstruction" placeholder="۱۴۰۲" maxlength="4" />
            </div>
            <div class="form-group">
              <label class="field-label">موبایل مالک / راننده</label>
              <input type="text" formControlName="strMobile" placeholder="09xxxxxxxxx" maxlength="11"
                oninput="this.value = this.value.replace(/[^0-9]/g,'')" />
            </div>
            <div class="form-group">
              <label class="field-label">مالک / راننده</label>
              <input type="text" formControlName="strFullName" placeholder="نام کامل" />
            </div>
            <div class="form-group">
              <label class="field-label">رمز عبور کاربر</label>
              <input type="text" formControlName="strPassword" placeholder="••••••••" />
            </div>
            <div class="form-group">
              <label class="field-label">کیلومتر فعلی (km)</label>
              <input type="text" formControlName="fLastKM" placeholder="مثلاً ۱۲۵۰۰۰"
                oninput="this.value = this.value.replace(/[^0-9]/g,'')" />
            </div>
            <div class="form-group">
              <label class="field-label">رنگ خودرو</label>
              <input type="text" formControlName="strColor" placeholder="مثلاً سفید" />
            </div>
            <div class="form-group">
              <label class="field-label">VIN خودرو</label>
              <input type="text" formControlName="strVIN" placeholder="۱۷ کاراکتر" maxlength="17" />
            </div>
            <div class="form-group span-full">
              <label class="field-label">توضیحات</label>
              <textarea formControlName="strComment" placeholder="توضیحات اختیاری..."></textarea>
            </div>
          </div>
          <div class="switches-grid" style="margin-top:20px;">
            <label class="switch-item">
              <span>فعال</span>
              <span class="toggle"><input type="checkbox" formControlName="bActive" /><span class="slider"></span></span>
            </label>
            <label class="switch-item">
              <span>اداری</span>
              <span class="toggle"><input type="checkbox" formControlName="bOfficial" /><span class="slider"></span></span>
            </label>
          </div>
        </div>
      </section>
    </div>
  </main>
  <!-- Action Bar -->
  <div class="action-bar">
    <!-- فرم با ردیاب / اداری -->
    <ng-container *ngIf="modeId == 1 || modeId == 3">
      <div class="action-main">
        <button *ngIf="!isEditMode" class="btn btn-success btn-lg" (click)="submitGpsForm()" [disabled]="isLoading">
          <i class="fa fa-check"></i> ثبت
        </button>
        <button *ngIf="isEditMode" class="btn btn-primary btn-lg" (click)="submitGpsForm()">
          <i class="fa fa-pencil"></i> ویرایش
        </button>
      </div>
      <div class="dropdown action-more" *ngIf="isEditMode || (car && car.bIncomplete)">
        <button class="btn btn-outline btn-more dropdown-toggle" type="button" data-bs-toggle="dropdown"
          aria-expanded="false" title="اقدامات بیشتر">
          <span class="more-text">اقدامات بیشتر</span>
        </button>
        <ul class="dropdown-menu dropdown-menu-end action-menu">
          <li class="menu-label"><span>عملیات</span></li>
          <li *ngIf="isEditMode">
            <button class="dropdown-item" (click)="openGreenPaper()">
              <span class="item-icon"><i class="fa fa-file-text-o"></i></span> برگ سبز
              <span class="item-hint">مشخصات سند</span>
            </button>
          </li>
          <li *ngIf="car?.bOfficial && isEditMode">
            <button class="dropdown-item" (click)="openOfficialStatus()">
              <span class="item-icon"><i class="fa fa-exchange"></i></span> تغییر وضعیت
              <span class="item-hint">وضعیت سفر</span>
            </button>
          </li>
          <li *ngIf="car?.bOfficial && isEditMode">
            <button class="dropdown-item" (click)="openExtraInfo()">
              <span class="item-icon"><i class="fa fa-info-circle"></i></span> اطلاعات تکمیلی
              <span class="item-hint">جزئیات بیشتر</span>
            </button>
          </li>
          <li *ngIf="isEditMode && permissions.bTariff">
            <button class="dropdown-item" data-bs-toggle="modal" data-bs-target="#tariff">
              <span class="item-icon"><i class="fa fa-money"></i></span> تعرفه خدمات
              <span class="item-hint">نرخ‌ها</span>
            </button>
          </li>
          <li *ngIf="isEditMode && permissions.bIOUsage">
            <button class="dropdown-item" data-bs-toggle="modal" data-bs-target="#workly-gps-modal">
              <span class="item-icon"><i class="fa fa-plug"></i></span> کاربری ورودی‌ها
              <span class="item-hint">سنسورها</span>
            </button>
          </li>
          <li *ngIf="car && car.bIncomplete">
            <button class="dropdown-item" (click)="logout()">
              <span class="item-icon"><i class="fa fa-sign-out"></i></span> خروج
            </button>
          </li>
          <li *ngIf="isEditMode && permissions.bDeleteCar"><hr class="dropdown-divider" /></li>
          <li *ngIf="isEditMode && permissions.bDeleteCar">
            <button class="dropdown-item item-danger" (click)="deleteCar()">
              <span class="item-icon"><i class="fa fa-trash"></i></span> حذف متحرک
              <span class="item-hint">غیرقابل بازگشت</span>
            </button>
          </li>
        </ul>
      </div>
    </ng-container>

    <!-- فرم بدون ردیاب -->
    <ng-container *ngIf="modeId == 2">
      <div class="action-main">
        <button *ngIf="!isEditMode" class="btn btn-success btn-lg" (click)="submitPlainForm()">
          <i class="fa fa-check"></i> ثبت
        </button>
        <button *ngIf="isEditMode" class="btn btn-primary btn-lg" (click)="submitPlainForm()">
          <i class="fa fa-pencil"></i> ویرایش
        </button>
      </div>
      <div class="dropdown action-more" *ngIf="isEditMode">
        <button class="btn btn-outline btn-more dropdown-toggle" type="button" data-bs-toggle="dropdown"
          aria-expanded="false" title="اقدامات بیشتر">
          <span class="more-text">اقدامات بیشتر</span>
        </button>
        <ul class="dropdown-menu dropdown-menu-end action-menu">
          <li class="menu-label"><span>عملیات خودرو</span></li>
          <li>
            <button class="dropdown-item" (click)="openGreenPaper()">
              <span class="item-icon"><i class="fa fa-file-text-o"></i></span> برگ سبز خودرو
              <span class="item-hint">مشخصات سند</span>
            </button>
          </li>
          <li *ngIf="isEditMode && permissions.bDeleteCar"><hr class="dropdown-divider" /></li>
          <li *ngIf="isEditMode && permissions.bDeleteCar">
            <button class="dropdown-item item-danger" (click)="deleteCar()">
              <span class="item-icon"><i class="fa fa-trash"></i></span> حذف خودرو
              <span class="item-hint">غیرقابل بازگشت</span>
            </button>
          </li>
        </ul>
      </div>
    </ng-container>
    <div class="spacer"></div>
  </div>
</div>

<!--تعرفه خدمات-->
<div class="modal fade" id="tariff" tabindex="-1" aria-labelledby="" aria-hidden="true">
    <div class="modal-dialog ">
        <div class="modal-content">
            <div class="modal-header dirI">
                <h5 class="modal-title" id=" ">تعرفه خدمات</h5>
                <button type="button " class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body d-flex flex-column dirI " [formGroup]="tariffForm">
                <div class="col-12 d-flex flex-row">
                    <div class="col-6 d-flex align-items-center">
                        <label>نرخ ساعتی (ریال) :</label>
                    </div>
                    <div class=" col-6 ">
                        <input class="form-control" type="number" formControlName="iHourlyRate">
                    </div>
                </div>
                <div class="col-12 d-flex flex-row">
                    <div class="col-6 d-flex align-items-center">
                        <label>نرخ اضافه کاری (ریال) :</label>
                    </div>
                    <div class=" col-6 mt-2">
                        <input class="form-control" type="number" formControlName="iOvertimeRate">
                    </div>
                </div>
                <div class="col-12 d-flex flex-row">
                    <div class="col-6 d-flex align-items-center">
                        <label>نرخ کیلومتر داخل شهر (ریال) :</label>
                    </div>
                    <div class=" col-6 mt-2">
                        <input class="form-control" type="number" formControlName="iUrbanOperationRates">
                    </div>
                </div>
                <div class="col-12 d-flex flex-row">
                    <div class="col-6 d-flex align-items-center">
                        <label>نرخ کیلومتر ماموریت (ریال) :</label>
                    </div>
                    <div class=" col-6 mt-2">
                        <input class="form-control" type="number" formControlName="iNonurbanOperatingRates">
                    </div>
                </div>
                <div class="col-12 d-flex flex-row">
                    <div class="col-6 d-flex align-items-center">
                        <label>نرخ توقف شبانه (ریال) :</label>
                    </div>
                    <div class=" col-6 mt-2">
                        <input class="form-control" type="number" formControlName="iOvernightStopRate">
                    </div>
                </div>
                <div class="col-12 d-flex flex-row">
                    <div class="col-6 d-flex align-items-center">
                        <label>اضافه کار تشویقی (ساعت) :</label>
                    </div>
                    <div class=" col-6 mt-2">
                        <input class="form-control " type="number" type="number" formControlName="iIncentiveOvertime">
                    </div>
                </div>
                <div class="col-12 d-flex flex-row">
                    <div class="col-6 d-flex align-items-center">
                        <label>پیمایش تشویقی(Km):</label>
                    </div>
                    <div class=" col-6 mt-2">
                        <input class="form-control " type="number" type="number" formControlName="iIncentiveKm">
                    </div>
                </div>
                <div class="col-12 d-flex flex-row">
                    <div class="col-6 d-flex align-items-center">
                        <label>ساعت شروع کار:</label>
                    </div>
                    <div class=" col-6 mt-2 clockpicker">
                        <input type="text" class="form-control shadow bg-light" id="Stime"
                            formControlName="strStartTime">
                        <span class="input-group-addon">
                            <span class="glyphicon glyphicon-time"></span>
                        </span>
                    </div>
                </div>
                <div class="col-12 d-flex flex-row">
                    <div class="col-6 d-flex align-items-center">
                        <label>ساعت پایان کار:</label>
                    </div>
                    <div class=" col-6 mt-2 clockpicker">
                        <input type="text" class="form-control shadow bg-light" formControlName="strEndTime" id="Etime">
                        <span class="input-group-addon">
                            <span class="glyphicon glyphicon-time"></span>
                        </span>
                    </div>
                </div>
            </div>
            <div class="modal-footer ">

                <button type="button " class="btn btn-primary" (click)="saveTariff()">ویرایش</button>
            </div>
        </div>
    </div>
</div>

<!-- کاربری ورودی ها -->
<div class="modal fade" id="workly-gps-modal" tabindex="-1" aria-labelledby="" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header dirI">
                <h5 class="modal-title" id="">کاربری ورودی ها</h5>
                <button type="button " class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>

            <div class="modal-body ">
                <div class="d-flex flex-wrap dirI justify-content-around align-items-end" [formGroup]="inputForm">
                    <div class="col-md-4 col-5">
                        <label>ورودی </label>
                        <select class="form-select" formControlName="strIOTitle">
                            <option value="-1">انتخاب کنید</option>
                            <option *ngFor="let item of inputTitles" value="{{item.strIOTitle}}">{{item.strIOTitle}}
                            </option>
                        </select>
                    </div>
                    <div class="col-md-4 col-5">
                        <label>کاربری ورودی </label>
                        <select class="form-select" formControlName="iIOUsage">
                            <option value="-1">انتخاب کنید</option>
                            <option *ngFor="let item of inputUsages" value="{{item.iIOUsage}}">{{item.strComment}}</option>

                        </select>
                    </div>
                    <div class="col-md-2 col-4 mt-2 mt-md-0">
                        <button class="btn btn-primary" (click)="addInputUsage()">اضافه کردن</button>
                    </div>
                </div>
                <hr>
                <div>
                    <table class="table table-striped border border-2 rounded-3 dirI">
                        <thead>
                            <!-- [ngClass]="showLocation  ? 'index-1' : ''" -->
                            <tr class="">
                                <th class="text-center">عملیات</th>
                                <th class="text-center">ورودی</th>
                                <th class="text-center">کاربری</th>

                            </tr>
                        </thead>
                        <tbody>
                            <tr class="" *ngFor="let item of inputAssignments; let i=index">
                                <td class="dirl f22 text-center pointer">

                                    <i class="fa fa-trash text-danger mx-1" title="حذف"
                                        (click)="deleteInputUsage(item.iIOMobileUsage)"></i>
                                    <i class="fa fa-edit text-warning mx-1" title="عنوان متناظر با مقدار ورودی"
                                        data-bs-toggle="modal" data-bs-target="#iOValueTitleModal"
                                        (click)="loadValueTitles(item.iIOMobileUsage)"></i>

                                </td>

                                <td class="text-center ">{{item.strIOTitle}}</td>
                                <td class="text-center "> {{item.strIOUsage_strComment}}</td>
                            </tr>

                        </tbody>
                    </table>
                </div>
            </div>

        </div>
    </div>
</div>

<!-- عنوان متناظر با مقدار ورودی -->
<div class="modal fade" id="iOValueTitleModal" tabindex="-1" aria-labelledby="" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header dirI">
                <h5 class="modal-title" id="">عنوان متناظر با مقدار ورودی </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body d-flex flex-wrap">
                <div class="col-12 d-flex flex-row dirI mt-1">

                    <table class="table table-striped border border-2 rounded-3 ">
                        <thead>
                            <!-- [ngClass]="showLocation  ? 'index-1' : ''" -->
                            <tr class="">
                                <th class="text-center">مقدار ورودی</th>
                                <th class="text-center">عنوان متناظر</th>
                                <th class="text-center">ویرایش عنوان</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="" *ngFor="let item of inputValueTitles; let i=index">
                                <td class="text-center">{{item.strValue}}</td>
                                <td class="text-center "><input class="form-control" type="text"
                                        value="{{item.strValueTitle}}" id="value{{item.strValue}}"></td>
                                <td class="text-center"><i class="fa fa-edit text-warning fa-2x pointer"
                                        (click)="saveValueTitle(item)"></i></td>

                            </tr>

                        </tbody>
                    </table>
                </div>
            </div>
            <div class="modal-footer dirI">
                <button type="button" class="btn btn-primary" data-bs-toggle="modal"
                    data-bs-target="#workly-gps-modal">برگشت</button>
            </div>
        </div>
    </div>
</div>

<!-- اطلاعات تکمیلی -->
<div class="modal fade" id="additionalInfoModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">

    <div class="modal-dialog modal-lg">

        <div class="modal-content dirI">

            <div class="modal-header">

                <h5 class="modal-title" id="exampleModalLabel"> اطلاعات تکمیلی </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body">

                <div [formGroup]="extraInfoForm" class="container-fluid row gx-2 gy-2 p-2">

                    <div class="position-relative col-12 col-md-4 p-2">

                        <label class="mb-2 text-muted"> شماره پرسنلی راننده </label>

                        <input class="form-control p-2 text-center" formControlName="strPersonnelID">

                    </div>

                    <div class="position-relative col-12 col-md-4 p-2">

                        <label class="mb-2 text-muted"> نوع خدمات سفر </label>

                        <select class="form-select" formControlName="tiAppUsages">

                            <option class="text-center" [value]="-1"> انتخاب کنید </option>

                            <option class="text-center" *ngFor="let item of appUsages" [value]="item.tiAppUsages">

                                {{item.strComment}}

                            </option>

                        </select>

                    </div>

                    <div class="position-relative col-12 col-md-4 p-2">

                        <label class="mb-2 text-muted"> حوزه خدمت </label>

                        <select class="form-select" formControlName="iMobileDomain">

                            <option class="text-center" [value]="-1"> انتخاب کنید </option>

                            <option class="text-center" *ngFor="let item of mobileDomains"
                                [value]="item.iMobileDomain">

                                {{item.strComment}}

                            </option>

                        </select>

                    </div>

                    <div class="position-relative col-12 col-md-4 p-2">

                        <label class="mb-2 text-muted"> کد شناسایی </label>

                        <input class="form-control p-2 text-center" formControlName="iCode">

                    </div>

                    <div class="position-relative col-12 col-md-4 p-2">

                        <label class="mb-2 text-muted"> شماره حساب </label>

                        <input class="form-control p-2 text-center" formControlName="strBankAccount"
                            oninput="this.value = this.value.replace(/[^0-9]/g,'')">

                    </div>

                    <div class="position-relative col-12 col-md-4 p-2">

                        <label class="mb-2 text-muted"> فاصله زمانی ارسال اطلاعات (ثانیه) </label>

                        <input class="form-control p-2 text-center" formControlName="iPeriodSendingLoc"
                            oninput="this.value = this.value.replace(/[^0-9]/g,'')">

                    </div>

                    <div class="position-relative col-12 col-md-4 p-2">

                        <label class="mb-2 text-muted"> فاصله مکانی ارسال اطلاعات (متر) </label>

                        <input class="form-control p-2 text-center" formControlName="iLocationCourseSending">

                    </div>

                    <div class="position-relative col-12 col-md-4 p-2 clockpicker">

                        <label class="mb-2 text-muted"> ساعت شروع فعالیت </label>

                        <input class="form-control p-2 text-center" formControlName="strStartTime" id="aStartTime"
                            readonly>

                    </div>

                    <div class="position-relative col-12 col-md-4 p-2 clockpicker">

                        <label class="mb-2 text-muted"> ساعت پایان فعالیت </label>

                        <input class="form-control p-2 text-center" formControlName="strEndTime" id="aEndTime" readonly>

                    </div>

                    <div class="position-relative col-12 col-md-4 p-2">

                        <label class="mb-2 text-muted"> شماره موبایل مرکز </label>

                        <input class="form-control p-2 text-center" formControlName="strManagerMobile">

                    </div>

                    <div class="form-check form-switch m-0 d-flex align-items-center col-12 p-2">

                        <input class="form-check-input m-0" type="checkbox" id="bEnableTimer" formControlName="bEnableTimer">

                        <label class="form-check-label pointer text-muted me-2" for="bEnableTimer"> تایمر دریافت اطلاعات از سرور  </label>

                    </div>

                    <div class="form-check form-switch m-0 d-flex align-items-center col-12 p-2">

                        <input class="form-check-input m-0" type="checkbox" id="bCheckPosition" formControlName="bCheckPosition4Ready">

                        <label class="form-check-label pointer text-muted me-2" for="bCheckPosition"> کنترل موقعیت راننده </label>

                    </div>

                    <div class="form-check form-switch m-0 d-flex align-items-center col-12 p-2">

                        <input class="form-check-input m-0" type="checkbox" id="bHastrafficLoc" formControlName="bHastrafficLoc">

                        <label class="form-check-label pointer text-muted me-2" for="bHastrafficLoc"> طرح ترافیک </label>

                    </div>

                    <div class="form-check form-switch m-0 d-flex align-items-center col-12 p-2">

                        <input class="form-check-input m-0" type="checkbox" id="bHasEvenoddb" formControlName="bHasEvenoddb">

                        <label class="form-check-label pointer text-muted me-2" for="bHasEvenoddb"> طرح کنترل آلودگی هوا </label>

                    </div>

                </div>

            </div>

            <div class="modal-footer d-flex justify-content-start">

                <button class="btn btn-success" (click)="saveExtraInfo()">

                    &nbsp; &nbsp; ویرایش &nbsp; &nbsp;

                </button>

                
                <button class="btn btn-outline-secondary" data-bs-dismiss="modal">

                    &nbsp; بستن &nbsp;

                </button>

            </div>

        </div>

    </div>

</div>

<!-- تغییر وضعیت -->
<div class="modal fade" id="officialStatus_Modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">

    <div class="modal-dialog">

        <div class="modal-content dirI">

            <div class="modal-header">

                <h5 class="modal-title" id="exampleModalLabel"> تغییر وضعیت سفر </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body">

                <div [formGroup]="extraInfoForm" class="position-relative col-auto p-2">

                    <label class="mb-2 text-muted"> وضعیت </label>

                    <select class="form-select" formControlName="tiOfficialStatus">

                        <option class="text-center" [value]="-1"> انتخاب کنید </option>

                        <option class="text-center" *ngFor="let item of officialStatuses" [value]="item.tiOfficialStatus">

                            {{item.strComment}}

                        </option>

                    </select>

                </div>

            </div>

            <div class="modal-footer d-flex justify-content-start">

                <button class="btn btn-primary" (click)="saveOfficialStatus()">

                    &nbsp; &nbsp; ویرایش &nbsp; &nbsp;

                </button>

                
                <button class="btn btn-outline-secondary" data-bs-dismiss="modal">

                    &nbsp; بستن &nbsp;

                </button>

            </div>

        </div>

    </div>

</div>

<!-- برگ سبز خودرو -->
<div class="modal fade" id="greenPaper_Modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">

    <div class="modal-dialog modal-xl">

        <div class="modal-content dirI">

            <div class="modal-header dirI">

                <h5 class="modal-title" id="exampleModalLabel"> اطلاعات برگ سبز خودرو </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body">

                <div [formGroup]="greenPaperForm" class="row gx-2 gy-2 p-2">

                    <!-- تعداد سیلندر -->

                    <div class="position-relative col-12 col-md-3 p-2">
            
                        <label class="mb-2 text-muted"> تعداد سیلندر </label>
            
                        <input oninput="this.value = this.value.replace(/[^0-9]/g,'')"

                            formControlName="tiCylinders"
                        
                            class="form-control p-2 text-center">
            
                    </div>

                    <!-- تعداد محور -->

                    <div class="position-relative col-12 col-md-3 p-2">
            
                        <label class="mb-2 text-muted"> تعداد محور </label>
            
                        <input oninput="this.value = this.value.replace(/[^0-9]/g,'')"

                            formControlName="tiAxis"
                        
                            class="form-control p-2 text-center">
            
                    </div>

                    <!-- تعداد چرخ -->

                    <div class="position-relative col-12 col-md-3 p-2">
            
                        <label class="mb-2 text-muted"> تعداد چرخ </label>
            
                        <input oninput="this.value = this.value.replace(/[^0-9]/g,'')"

                            formControlName="tiWheels"
                        
                            class="form-control p-2 text-center">
            
                    </div>

                    <!-- شماره موتور -->

                    <div class="position-relative col-12 col-md-3 p-2">
            
                        <label class="mb-2 text-muted"> شماره موتور </label>
            
                        <input formControlName="strEngineNumber" class="form-control p-2 text-center">
            
                    </div>

                    <!-- شماره شاسی -->

                    <div class="position-relative col-12 col-md-3 p-2">
            
                        <label class="mb-2 text-muted"> شماره شاسی </label>
            
                        <input formControlName="strChassisNumber" class="form-control p-2 text-center">
            
                    </div>
                    
                    <!-- حجم سیلندر -->

                    <div class="position-relative col-12 col-md-3 p-2">
            
                        <label class="mb-2 text-muted"> حجم سیلندر </label>
            
                        <input oninput="this.value = this.value.replace(/[^0-9]/g,'')"

                            formControlName="iCylinderVolume"
                        
                            class="form-control p-2 text-center">
            
                    </div>

                    <!-- نام و نام خانوادگی مالک  -->

                    <div class="position-relative col-12 col-md-3 p-2">
            
                        <label class="mb-2 text-muted"> نام و نام خانوادگی مالک  </label>
            
                        <input formControlName="strOwnerFullName" class="form-control p-2 text-center">
            
                    </div>

                    <!-- نام پدر  -->

                    <div class="position-relative col-12 col-md-3 p-2">
            
                        <label class="mb-2 text-muted"> نام پدر  </label>
            
                        <input formControlName="strOwnerFatherName" class="form-control p-2 text-center">
            
                    </div>

                    <!-- تاریخ تولد -->
            
                    <div class="position-relative col-12 col-md-3 p-2">
            
                        <label class="mb-2 text-muted"> تاریخ تولد </label>
            
                        <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"

                            [dateInitValue]="true" [dateFormat]="'jYYYY/jMM/jDD'">
            
                            <input formControlName="strOwnerBirthDate" class="form-control text-center" />
            
                        </ng-persian-datepicker>
            
                    </div>

                    <!-- شماره شناسنامه -->

                    <div class="position-relative col-12 col-md-3 p-2">
            
                        <label class="mb-2 text-muted"> شماره شناسنامه </label>
            
                        <input formControlName="strOwnerCertificateNumber" class="form-control p-2 text-center">
            
                    </div>
            
                    <!-- شماره ملی -->

                    <div class="position-relative col-12 col-md-3 p-2">
            
                        <label class="mb-2 text-muted"> شماره ملی </label>
            
                        <input formControlName="strOwnerNationalCode" class="form-control p-2 text-center">
            
                    </div>
            
                    <!-- محل صدور -->

                    <div class="position-relative col-12 col-md-3 p-2">
            
                        <label class="mb-2 text-muted"> محل صدور </label>
            
                        <input formControlName="strOwnerPlaceIssue" class="form-control p-2 text-center">
            
                    </div>
            
                    <!-- کد پستی -->

                    <div class="position-relative col-12 col-md-3 p-2">
            
                        <label class="mb-2 text-muted"> کد پستی </label>
            
                        <input formControlName="strOwnerPostalCode" class="form-control p-2 text-center">
            
                    </div>
            
                    <!-- آدرس -->

                    <div class="position-relative col-12 p-2">

                        <label class="mb-2 text-muted"> آدرس </label>
            
                        <textarea formControlName="strOwnerAdress" style="height: 100px;resize: none;" class="form-control"></textarea>
            
                    </div>
            
                </div>

            </div>

            <div class="modal-footer d-flex justify-content-start">

                <button class="btn btn-success" (click)="saveGreenPaper()">

                    &nbsp; &nbsp; ثبت &nbsp; &nbsp;

                </button>

                <button class="btn btn-outline-secondary" data-bs-dismiss="modal">

                    &nbsp; بستن &nbsp;

                </button>

            </div>

        </div>

    </div>

</div>


